<template>
   <div>
     <lottie v-if="defaultOptions" :options="defaultOptions" :height="300" :width="300" v-on:animCreated="handleAnimation"/>
   </div>
</template>

<script>
import firebase, { firestore } from "firebase/app";
import "firebase/database";
import moment from "moment-timezone";
const axios = require("axios").default;
import router from "./../router";
import _ from 'lodash';
import Tabs from 'vue-tabs-with-active-line';
import Lottie from './lottie.vue';
import { loadAnimation } from '@/services/lottieLoader';
import liffService from "@/services/liff";

// @ is an alias to /src
export default {
  name: "ShareAll",
  async created() {
    // LIFF is already initialized by router guard
    this.loadUserData();
    const animate = await loadAnimation('share');
    this.defaultOptions = {animationData: animate};
  },
  components: {
      'lottie': Lottie
  },
  data() {
    return {
      displayName: "",
      //email: "",
      userId: "",//Uf67a993bc2d1d206693634a1ba806798
      pictureUrl: "",
      statusMessage: "",
      firstname: "",
      master: "5",
      agent: "-MBjPYX3fRJGs3gklUHq",
      lastname: "",
      bank: "",
      accountNo: "",
      tel: "",
      mastername: "",
      isDisabled: true,
      loading: true,
      error: "",
      mycoin:0,
      rewards:[],
      userKey:'',
      quizId:0,
      answer:0,
      defaultOptions: null,
      animationSpeed: 1,
      linkline:"https://lin.ee/9MgANfz",
    };
  },
  methods: {
    handleAnimation: function (anim) {
        this.anim = anim;
    },
    async shareFriend(){
      const result = await window.liff.shareTargetPicker([
        {
          "type": "flex",
          "altText": "UFA Easy888",
          "contents": {
              "type": "bubble",
              "size": "giga",
              "hero": {
                "type": "image",
                "url": "https://line-ufaeasy2.web.app/images/line-header.jpg",
                "size": "full",
                "aspectRatio": "20:13",
                "aspectMode": "cover",
                "action": {
                  "type": "uri",
                  "uri": this.linkline
                }
              },
            "body": {
              "type": "box",
              "layout": "vertical",
              "spacing": "md",
              "contents": [
                {
                  "type": "text",
                  "text": "UFA Easy888",
                  "wrap": true,
                  "weight": "bold",
                  "gravity": "center",
                  "size": "xl"
                },
                {
                  "type": "box",
                  "layout": "baseline",
                  "margin": "md",
                  "contents": [
                    {
                      "type": "icon",
                      "size": "sm",
                      "url": "https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png"
                    },
                    {
                      "type": "icon",
                      "size": "sm",
                      "url": "https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png"
                    },
                    {
                      "type": "icon",
                      "size": "sm",
                      "url": "https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png"
                    },
                    {
                      "type": "icon",
                      "size": "sm",
                      "url": "https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png"
                    },
                    {
                      "type": "icon",
                      "size": "sm",
                      "url": "https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png"
                    },
                    {
                      "type": "text",
                      "text": "5.0",
                      "size": "sm",
                      "color": "#999999",
                      "margin": "md",
                      "flex": 0
                    }
                  ]
                },
                {
                  "type": "box",
                  "layout": "vertical",
                  "margin": "lg",
                  "spacing": "sm",
                  "contents": [
                    {
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": "🔥 UFA Easy888 [เว็บตรงไม่ผ่านเอเย่นต์]",
                          "wrap": true,
                          "size": "sm",
                          "color": "#666666",
                          "flex": 4
                        }
                      ]
                    },
                    {
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": "🔥 เว็บกีฬาออนไลน์ ที่มาแรงที่สุดในตอนนี้",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    },
                    {
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": "🔥 การเงินมั่นคงปลอดภัย 100 %",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    },
                    {
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": "🔥 ดูแลการเงินด้วยแอดมิน ตลอด 24 ชั่วโมง",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    },
                    {
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": "🔥 บอล หวย มวย คาสิโน เกมส์ ครบวงจร",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    },
                    {
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": "🔥 เราใช้ระบบใหม่และดีที่สุดตอนนี้",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    },
                    {
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": "🔥 ระบบแจ้งฝากและถอนได้รวดเร็วที่สุด",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    },
                    // {
                    //   "type": "box",
                    //   "layout": "baseline",
                    //   "spacing": "sm",
                    //   "contents": [
                    //     {
                    //       "type": "text",
                    //       "text": "🔥 ระบบเราสามารถดู History ย้อนหลังได้",
                    //       "wrap": true,
                    //       "color": "#666666",
                    //       "size": "sm",
                    //       "flex": 4
                    //     }
                    //   ]
                    // },
                    // {
                    //   "type": "box",
                    //   "layout": "baseline",
                    //   "spacing": "sm",
                    //   "contents": [
                    //     {
                    //       "type": "text",
                    //       "text": "🔥 สามารถเข้าเล่นได้เพียงกดปุ่มเดียว",
                    //       "wrap": true,
                    //       "color": "#666666",
                    //       "size": "sm",
                    //       "flex": 4
                    //     }
                    //   ]
                    // },
                    {
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": "🔥 ฝาก - ถอน ภายใน 10 วินาที",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    },
                    {
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": "🔥 Auto Login เข้าเล่นอัตโนมัติ ไม่ต้องจำรหัส",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    },
                    {
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": "🔥 ฝาก แรกของวัน",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    },{
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": " - รับเพิ่ม 5%",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    },{
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": " - รับแต้ม X2",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    },{
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": " - โบนัสถอนได้",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    },{
                      "type": "box",
                      "layout": "baseline",
                      "spacing": "sm",
                      "contents": [
                        {
                          "type": "text",
                          "text": " - ไม่ต้องทำเทิร์น",
                          "wrap": true,
                          "color": "#666666",
                          "size": "sm",
                          "flex": 4
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            "footer": {
              "type": "box",
              "layout": "horizontal",
              "contents": [
                {
                  "type": "spacer",
                  "size": "xs"
                },
                {
                  "type": "button",
                  "style": "primary",
                  "color": "#a99955",
                  "action": {
                    "type": "uri",
                    "label": "สมัครสมาชิก",
                    "uri": this.linkline
                  }
                },
                {
                  "type": "button",
                  "style": "primary",
                  "color": "#a99955",
                  "action": {
                    "type": "uri",
                    "label": "แชร์ให้เพื่อน",
                    "uri": "https://liff.line.me/2006378234-rZ9PYqmz/?userId="+this.userId
                  },
                  "margin": "10px"
                }
              ]
            }
          }
        }
      ]);
      if(result){
        alert('แชร์เพื่อนเรียบร้อยแล้ว ขอบคุณมากค่ะ');
        window.liff.closeWindow();
      }
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";

      const queryString = decodeURIComponent(window.location.search);
      const params = new URLSearchParams(queryString);
      if(params.get("userId")){
          this.userId = params.get("userId");
          this.linkline = 'https://liff.line.me/2006378234-72e9GVNa/register?userId='+params.get("userId");
      }
      this.shareFriend();
    },
  }
};
</script>
<style scoped>
#cover-spin {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
}

@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#cover-spin::after {
  content: "";
  display: block;
  position: absolute;
  left: 48%;
  top: 40%;
  width: 40px;
  height: 40px;
  border-style: solid;
  border-color: black;
  border-top-color: transparent;
  border-width: 4px;
  border-radius: 50%;
  -webkit-animation: spin 0.8s linear infinite;
  animation: spin 0.8s linear infinite;
}
.canredeem {
  border-radius: 7px; 
  margin-top: 10px; 
  height: 32px; 
  background: #EE4D2D; 
  align-items: center; 
  justify-content: center; 
  display: flex;
}
.cantredeem {
  border-radius: 7px; 
  margin-top: 10px; 
  height: 32px; 
  background: #a5a4a4; 
  align-items: center; 
  justify-content: center; 
  display: flex;
}
button.tabs__item .tabs__item_active .default-tabs__item_active .default-tabs__item {
  justify-content: center !important;
  flex: 1 !important;
  display: flex !important;
}
</style>
<style lang="scss">
.default-tabs {
  position: relative;
  margin: 0 auto;
  display: flex;
  &__item {
    justify-content: center;
    flex: 1;
    display: flex;
    //display: inline-block;
    margin: 0 5px;
    padding: 10px;
    padding-bottom: 8px;
    padding-top: 0px;
    font-size: 16px;
    letter-spacing: 0.8px;
    color: #fff;
    text-decoration: none;
    border: none;
    background-color: transparent;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    transition: all 0.25s;
    &_active {
      color: #E95454;
    }
    &:hover {
      border-bottom: 2px solid #E95454;
      color: #E95454;
    }
    &:focus {
      outline: none;
      border-bottom: 2px solid #E95454;
      color: #E95454;
    }
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  &__active-line {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    background-color: #E95454;
    transition: transform 0.4s ease, width 0.4s ease;
  }
}
</style>